export default __webpack_public_path__ + "static/media/misc-drawerA-1440w.17de7532.png";